/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_CommentsInputs */

const en__field_comments = /** @type {(inputs: _Field_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History/Comments`)
};

const de__field_comments = /** @type {(inputs: _Field_CommentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlauf/Kommentare`)
};

/**
* | output |
* | --- |
* | "History/Comments" |
*
* @param {_Field_CommentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_comments = /** @type {((inputs?: _Field_CommentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_CommentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_comments(inputs)
	return de__field_comments(inputs)
});